import { BottomSheet } from 'components/Toolkit/BottomSheet/BottomSheet';
import { SecondarySelect } from 'features/location/components/SecondarySelect/SecondarySelect';
import { SearchInputAndPrimarySelect } from 'features/location/components/SearchInputAndPrimarySelect/SearchInputAndPrimarySelect';

import * as LocationStyles from 'features/location/Location.styled';

import { Desktop } from 'components/Support/Desktop/Desktop';
import { Mobile } from 'components/Support/Mobile/Mobile';

import { LEVELS, LocationProps } from 'features/location/Location.typed';
import {
  BOTTOM_SHEET_HEIGHT,
  DEFAULT_PRESELECT,
  DESKTOP_SKELETON_LIST_LENGTH,
  MOBILE_SKELETON_LIST_LENGTH,
} from 'features/location/Location.constants';
import { useLocationContext } from 'features/location/Location.context';

function Location(props: LocationProps) {
  const {
    secondarySelectWidth = '100%',
    maxHeight,
    displayInline,
    maxTextContainerWidthMWeb = '100%',
    maxTextContainerWidthWeb = '100%',
  } = props;

  const {
    isLocationBottomSheetOpen,
    isExpanded,
    setIsLocationBottomSheetOpen,
    setIsExpanded,
    locationDisplay,
    level,
  } = useLocationContext();

  const resetScrollPosition = level === LEVELS.LEVEL_TWO;

  return (
    <>
      <Mobile>
        <LocationStyles.InputButtonWithSecondarySelect
          displayInline={displayInline}
        >
          <LocationStyles.SInputButton
            isActive={isLocationBottomSheetOpen}
            value={locationDisplay}
            onClick={() => setIsLocationBottomSheetOpen(true)}
            placeholder={DEFAULT_PRESELECT.displayName}
            variant={displayInline ? 'DEFAULT' : 'COMFORT'}
            textContainerMaxWidth={maxTextContainerWidthMWeb}
            displayInline={displayInline}
          />
          <LocationStyles.SecondarySelectContainer
            secondarySelectWidth={secondarySelectWidth}
          >
            {displayInline && (
              <LocationStyles.Arrow>
                <LocationStyles.ArrowLeft />
                <LocationStyles.ArrowCurve />
                <LocationStyles.ArrowBottom />
                <LocationStyles.ArrowHeadTop />
                <LocationStyles.ArrowHeadBottom />
              </LocationStyles.Arrow>
            )}
            <SecondarySelect displayInline={displayInline} />
          </LocationStyles.SecondarySelectContainer>
        </LocationStyles.InputButtonWithSecondarySelect>
        <BottomSheet
          headerText={locationDisplay || DEFAULT_PRESELECT.displayName}
          askToClose={() => setIsLocationBottomSheetOpen(false)}
          isOpen={isLocationBottomSheetOpen}
          optionSelected={Boolean(locationDisplay)}
          resetScrollPosition={resetScrollPosition}
          height={BOTTOM_SHEET_HEIGHT}
          onApply={() => setIsLocationBottomSheetOpen(false)}
        >
          <SearchInputAndPrimarySelect
            skeletonListLength={MOBILE_SKELETON_LIST_LENGTH}
            isLocationBottomSheetOpen={isLocationBottomSheetOpen}
            isExpanded={false}
          />
        </BottomSheet>
      </Mobile>
      <Desktop>
        <LocationStyles.Container displayInline={displayInline}>
          <LocationStyles.SDropdown
            expanded={isExpanded}
            setExpanded={setIsExpanded}
            placeholder={DEFAULT_PRESELECT.displayName}
            displayedValue={locationDisplay}
            variant={displayInline ? 'DEFAULT' : 'COMFORT'}
            cssStyles={
              !displayInline ? LocationStyles.DropdownStyles : undefined
            }
            maxHeight={maxHeight}
            resetScrollPosition={resetScrollPosition}
            displayInline={displayInline}
            textContainerMaxWidth={maxTextContainerWidthWeb}
          >
            <SearchInputAndPrimarySelect
              skeletonListLength={DESKTOP_SKELETON_LIST_LENGTH}
              autoFocus
              isLocationBottomSheetOpen={false}
              isExpanded={isExpanded}
            />
          </LocationStyles.SDropdown>
          <LocationStyles.SecondarySelectContainer
            secondarySelectWidth={secondarySelectWidth}
          >
            {displayInline && (
              <LocationStyles.Arrow>
                <LocationStyles.ArrowLeft />
                <LocationStyles.ArrowCurve />
                <LocationStyles.ArrowBottom />
                <LocationStyles.ArrowHeadTop />
                <LocationStyles.ArrowHeadBottom />
              </LocationStyles.Arrow>
            )}
            <SecondarySelect displayInline={displayInline} />
          </LocationStyles.SecondarySelectContainer>
        </LocationStyles.Container>
      </Desktop>
    </>
  );
}

export { Location };
